import React, { createRef, useEffect, useState } from "react";
import {
  makeStyles,
  Divider,
  Chip,
  Container,
  Box,
  Card,
  CardHeader,
} from "@material-ui/core";

import MaterialTable from "material-table";

import { useSelector, useDispatch } from "react-redux";

import { AlertTitle, Alert } from "@material-ui/lab";
import _ from "lodash";
import {
  getAllRoles,
  getAllUsers,
  getAllUserProfiles,
  updateUserRole,
  updateMultipleUserRole,
  updateUserApprover,
  getAllUserDepartments,
} from "src/redux/actions/backOffice.action";
import Swal from "sweetalert2";
import { httpClient } from "src/utils/HttpClient";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import { hasRole } from "src/utils/Auth";
import { getAllApprovers } from "./../../../../redux/actions/backOffice.action";
import { useHistory, useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

const UserProfileComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tableRef = createRef();
  const history = useHistory();
  const params = useParams();
  const [selectedRow, setSelectedRow] = useState(null);
  const { users, roles, approvers, userDepartments } = useSelector(
    (state) => state.backOfficeReducer
  );
  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  useEffect(() => {
    dispatch(getAllRoles());
    dispatch(getAllUserDepartments());
    dispatch(
      getAllUserProfiles({
        USER_ID: "",
        USER_NAME: "",
        DATA_UPDATE_STATUS: "",
        STATUS: "",
        DEPARTMENT: "",
      })
    );
    dispatch(getAllApprovers());
  }, []);

  if (users.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert — <strong>Get Users data!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page className={classes.root} title="User Management">
      <Container maxWidth="xl">
        <Box mb={2}>
          <Card>
            <CardHeader subheader="" title="User Profile Search" />
            <Divider />
          </Card>
        </Box>
        <Box mb={2}>
          <Toolbar
            onSubmit={(value) => {
              dispatch(getAllUserProfiles(value));
            }}
            roles={roles.data}
            departments={userDepartments.data}
          />
        </Box>
        <MaterialTable
          title
          ref={tableRef}
          // isLoading={users.isLoading || roles.isLoading}
          isLoading={users.isLoading}
          columns={[
            {
              title: "User ID",
              field: "PER_ACCOUNTNAME",
            },
            {
              title: "Employee ID",
              field: "EMPLOYEE_ID",
            },
            {
              title: "User Name",
              field: "USER_NAME",
            },
            {
              title: "Title",
              field: "TITLE",
            },
            {
              title: "Data Update Status",
              field: "DATA_UPDATE_STATUS",
            },
            {
              title: "Status",
              field: "DOA_ACTIVE",
              lookup: { 0: "Inactive", 1: "Active" },
            },
            {
              title: "Division",
              field: "DEVISION_NAME",
            },
            {
              title: "Department",
              field: "DEPART_NAME",
            },
            {
              title: "Job Grade",
              field: "MLEVEL",
            },
            {
              title: "Role",
              field: "ROLE",
            },
            {
              title: "DOA Level",
              field: "DOA_LEVEL",
            },
            {
              title: "Email Approval",
              field: "EMAIL_APPROVE",
            },
            {
              title: "Email Update Status",
              field: "EMAIL_UPDATE_STATUS",
            },
          ]}
          data={users.data}
          actions={[
            (rowData) => ({
              icon: "check",
              tooltip: "Edit",
              onClick: (event, rowData) => {
                event.preventDefault();
                history.push(`user-profile-edit/${rowData.PER_ID}`);
              },
            }),
          ]}
          options={{
            search: false,
          }}
        />
      </Container>
    </Page>
  );
};

export default UserProfileComponent;
